// Lib
import React from 'react';

// Components
import Icon from '../../../../../../components/icons/Icon';

// Styles
import './NotificationFigureReminder.scss';

const NotificationFigureReminder = () => (
    <div className="NotificationFigureReminder">
        <Icon name="clock" />
    </div>
);

export default NotificationFigureReminder;
